import React from 'react';
import { Grid, Grow, Typography } from '@material-ui/core';

import NewsCard from './NewsCard/NewsCard';
import useStyles from './styles.js';

const infoCards = [
  { color: '#9d79bc', title: 'General News ', text: 'Show me the recent news' },
  { color: '#9d79bc', title: 'Filter by Technology', info: 'Smartphones Riot Game ,Netflix,BTC ', text: "PS5 / Bitcoin Or what's up with Bitcoin" },
  { color: '#9d79bc', title: 'Filter by Sources', info: 'CNN , BBC News, Le Monde, , Buzzfeed', text: 'Tell me the news from BBC News ' },
  { color: '#9d79bc', title: 'Filter by Categorie', info: 'Sports ,Politic,Science , Business, Meta ', text: 'Sports / Meta Or Show me Science News ' },
];

const NewsCards = ({ articles, activeArticle }) => {
  const classes = useStyles();

  if (!articles.length) {
    return (
      <Grow in>
        <Grid className={classes.container} container alignItems="stretch" spacing={3}>
          {infoCards.map((infoCard) => (
            <Grid item xs={12} sm={6} md={4} lg={3} className={classes.infoCard}>
              <div className={classes.card} style={{ backgroundColor: infoCard.color,color:"black",text_align:"center",font_family:"Times New Roamn" }}>
                <Typography variant="h5" component="h5">{infoCard.title}</Typography>
                {infoCard.info ? <Typography variant="h6" component="h6"><strong>{"Like"}</strong>: <br />{infoCard.info}</Typography> : null}
                <Typography variant="h6" component="h6">Try saying like : <br /> <i>{infoCard.text}</i></Typography>
              </div>
            </Grid>
          ))}
        </Grid>
      </Grow>
    );
  }

  return (
    <Grow in>
      <Grid className={classes.container} container alignItems="stretch" spacing={3}>
        {articles.map((article, i) => (
          <Grid item xs={12} sm={6} md={4} lg={3} style={{ display: 'flex' }}>
            <NewsCard activeArticle={activeArticle} i={i} article={article} />
          </Grid>
        ))}
      </Grid>
    </Grow>
  );
};

export default NewsCards;